import moment from 'moment'

import { IReceipt, ReceiptType } from '@/types/receipt'
import { IUser, UserRole } from '@/types/user'

import { hasNg } from '@/utils/validation'
import { WorkResult } from '@/types/log'
import {
  ISpecialOfferReceipt,
  SpecialOfferReceiptType,
} from '@/types/special-offer'

export const okOrNg = (
  receipt: IReceipt,
  user: IUser,
  receiptType: ReceiptType,
): IReceipt => {
  receipt.items.forEach(item => {
    if (item.id) {
      item.createdByUserId = user.id
    }
    item.updatedByUserId = user.id
  })

  if (receiptType !== 'uncheckedSystemNg' && receiptType !== 'systemNg') {
    // 1. システムNGから、店舗修正の場合
    // 2. システムNGから、日付だけ修正の場合
    //   -> 未処理へ行くべき
    // そうでないなら、そのままUpdate
    receipt.needReProcess = false
  }
  if (
    receiptType === 'systemNg' &&
    receipt.ngReason === null &&
    receipt.otherNgReason.length === 0
  ) {
    // NG系から、NGがなくなった
    //   -> 未処理へ行くべき
    receipt.needReProcess = true
  }

  if (hasNg(receipt)) {
    receipt.items.forEach(item => {
      item.isFinallyAutoMatched = false
    })
    switch (receiptType) {
      case 'unchecked':
      case 'systemOk':
        switch (user.role) {
          case UserRole.LINKER:
            return {
              ...receipt,
              linkerNgedAt: moment().toDate(),
              ngedByLinkerId: user.id,
            }
          case UserRole.LEADER:
          case UserRole.ADMIN:
          default:
            return {
              ...receipt,
              leaderNgedAt: moment().toDate(),
              ngedByLeaderId: user.id,
            }
        }

      case 'linkerChecked':
      case 'leaderChecked':
        switch (user.role) {
          case UserRole.LEADER:
          case UserRole.ADMIN:
            return {
              ...receipt,
              leaderNgedAt: moment().toDate(),
              ngedByLeaderId: user.id,
            }
          default:
            return receipt
        }

      case 'uncheckedSystemNg':
      case 'systemNg':
        switch (user.role) {
          case UserRole.LINKER:
            return {
              ...receipt,
              linkerNgedAt: moment().toDate(),
              ngedByLinkerId: user.id,
            }
          case UserRole.LEADER:
          case UserRole.ADMIN:
          default:
            return {
              ...receipt,
              leaderNgedAt: moment().toDate(),
              ngedByLeaderId: user.id,
            }
        }

      case 'linkerNg':
      case 'leaderNg':
        switch (user.role) {
          case UserRole.LEADER:
          case UserRole.ADMIN:
            return {
              ...receipt,
              leaderNgedAt: moment().toDate(),
              ngedByLeaderId: user.id,
            }
          default:
            return receipt
        }
      case 'shopUnchecked':
        return receipt
      case 'newItem':
        return receipt
      case 'reItem':
        return receipt
    }
  }

  switch (receiptType) {
    case 'unchecked':
    case 'systemOk':
      switch (user.role) {
        case UserRole.LINKER:
          return {
            ...receipt,
            linkerOkedAt: moment().toDate(),
            okedByLinkerId: user.id,
          }
        case UserRole.LEADER:
        case UserRole.ADMIN:
        default:
          return {
            ...receipt,
            leaderOkedAt: moment().toDate(),
            okedByLeaderId: user.id,
          }
      }

    case 'linkerChecked':
    case 'leaderChecked':
      switch (user.role) {
        case UserRole.LEADER:
        case UserRole.ADMIN:
          return {
            ...receipt,
            leaderOkedAt: moment().toDate(),
            okedByLeaderId: user.id,
          }
        default:
          return receipt
      }

    case 'uncheckedSystemNg':
    case 'systemNg':
      switch (user.role) {
        case UserRole.LINKER:
          return {
            ...receipt,
            linkerOkedAt: moment().toDate(),
            okedByLinkerId: user.id,
          }
        case UserRole.LEADER:
        case UserRole.ADMIN:
        default:
          return {
            ...receipt,
            leaderOkedAt: moment().toDate(),
            okedByLeaderId: user.id,
          }
      }

    case 'linkerNg':
    case 'leaderNg':
      switch (user.role) {
        case UserRole.LEADER:
        case UserRole.ADMIN:
          return {
            ...receipt,
            leaderOkedAt: moment().toDate(),
            okedByLeaderId: user.id,
          }
        default:
          return receipt
      }
    case 'shopUnchecked':
      return receipt
    case 'newItem':
      return receipt
    case 'reItem':
      return receipt
  }
}

export const getLog = (
  receipt: IReceipt,
  receiptType: ReceiptType,
): [ReceiptType, WorkResult] => {
  if (hasNg(receipt)) {
    return [receiptType, WorkResult.NG]
  } else {
    return [receiptType, WorkResult.OK]
  }
}

export const getSlog = (
  specialOfferReceipt: ISpecialOfferReceipt,
  receiptType: SpecialOfferReceiptType,
): [SpecialOfferReceiptType, WorkResult] => {
  if (hasNg(specialOfferReceipt)) {
    return [receiptType, WorkResult.NG]
  } else {
    return [receiptType, WorkResult.OK]
  }
}
